import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
const MonthDatePicker = ({ label = "Select Month", value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        views={["month", "year"]}
        value={value}
        onChange={onChange}
        maxDate={dayjs()}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          padding: 0,
          "& .MuiInputBase-root": {
            fontSize: "14px",
            height: "36px",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1rem",
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
            transform: "translate(14px, -6px) scale(0.75)",
          },
         
        }}
      />
    </LocalizationProvider>
  );
};

export default MonthDatePicker;
